<template>
  <div
    class="flex w-full justify-center items-center z-10"
    :class="[stickToTop ? 'sticky top-0' : 'relative']"
    :style="`background-color: ${finalBgColor}`"
  >
    <div class="w-11/12 lg:w-9/12">
      <div class="flex justify-between items-center pt-5 pb-3">
        <slot name="logo"></slot>
        <slot name="profile"></slot>
        <slot name="button"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: {
    templateId: {},
    myBgColor: {},
    heroBgColor: {},
    transNabBar: {},
    stickToTop: {},
  },
  computed: {
    finalBgColor() {
      if (this.transNabBar) {
        if (this.templateId == 1) {
          return this.heroBgColor;
        }
        if (this.templateId == 2) {
          return 'transparent';
        }
      }
      if (this.stickToTop) {
        return this.myBgColor;
      }
      return this.myBgColor;
    },
  },
};
</script>
